// extracted by mini-css-extract-plugin
module.exports = {"labelOptional":"Label_labelOptional__JfgZU","label":"Label_label__1D7FC"};